import { render } from "./Datebox.vue?vue&type=template&id=3bd39cc1&ts=true"
import script from "./Datebox.vue?vue&type=script&lang=ts"
export * from "./Datebox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__